export var ChannelsItem;
(function (ChannelsItem) {
    ChannelsItem["PUSH"] = "PUSH";
    ChannelsItem["IN_APP"] = "IN_APP";
})(ChannelsItem || (ChannelsItem = {}));
export var AdminLevel;
(function (AdminLevel) {
    AdminLevel["SUPER_ADMIN"] = "SUPER_ADMIN";
})(AdminLevel || (AdminLevel = {}));
export var AdminStatus;
(function (AdminStatus) {
    AdminStatus["ACTIVE"] = "ACTIVE";
    AdminStatus["SUSPENDED"] = "SUSPENDED";
    AdminStatus["DELETED"] = "DELETED";
})(AdminStatus || (AdminStatus = {}));
export var SocialProvider;
(function (SocialProvider) {
    SocialProvider["GOOGLE"] = "GOOGLE";
    SocialProvider["APPLE"] = "APPLE";
    SocialProvider["KAKAO"] = "KAKAO";
    SocialProvider["NAVER"] = "NAVER";
})(SocialProvider || (SocialProvider = {}));
export var SuspensionType;
(function (SuspensionType) {
    SuspensionType["TEMPORARY"] = "TEMPORARY";
    SuspensionType["PERMANENT"] = "PERMANENT";
})(SuspensionType || (SuspensionType = {}));
export var ChatMessageType;
(function (ChatMessageType) {
    ChatMessageType["TEXT_MESSAGE"] = "TEXT_MESSAGE";
    ChatMessageType["IMAGE_MESSAGE"] = "IMAGE_MESSAGE";
    ChatMessageType["SYSTEM"] = "SYSTEM";
})(ChatMessageType || (ChatMessageType = {}));
export var MessageType;
(function (MessageType) {
    MessageType["TEXT_MESSAGE"] = "TEXT_MESSAGE";
    MessageType["IMAGE_MESSAGE"] = "IMAGE_MESSAGE";
})(MessageType || (MessageType = {}));
export var BidAmountCurrency;
(function (BidAmountCurrency) {
    BidAmountCurrency["KRW"] = "KRW";
})(BidAmountCurrency || (BidAmountCurrency = {}));
export var NewCurrentPriceCurrency;
(function (NewCurrentPriceCurrency) {
    NewCurrentPriceCurrency["KRW"] = "KRW";
})(NewCurrentPriceCurrency || (NewCurrentPriceCurrency = {}));
export var MinimumBidPriceCurrency;
(function (MinimumBidPriceCurrency) {
    MinimumBidPriceCurrency["KRW"] = "KRW";
})(MinimumBidPriceCurrency || (MinimumBidPriceCurrency = {}));
export var AuctionType;
(function (AuctionType) {
    AuctionType["GENERAL"] = "GENERAL";
    AuctionType["FIRST_COME"] = "FIRST_COME";
    AuctionType["BLIND"] = "BLIND";
})(AuctionType || (AuctionType = {}));
export var FinalPriceCurrency;
(function (FinalPriceCurrency) {
    FinalPriceCurrency["KRW"] = "KRW";
})(FinalPriceCurrency || (FinalPriceCurrency = {}));
export var AuctionStatus;
(function (AuctionStatus) {
    AuctionStatus["SCHEDULED"] = "SCHEDULED";
    AuctionStatus["ACTIVE"] = "ACTIVE";
    AuctionStatus["ENDED"] = "ENDED";
    AuctionStatus["CANCELLED"] = "CANCELLED";
})(AuctionStatus || (AuctionStatus = {}));
export var CurrentPriceCurrency;
(function (CurrentPriceCurrency) {
    CurrentPriceCurrency["KRW"] = "KRW";
})(CurrentPriceCurrency || (CurrentPriceCurrency = {}));
export var StartingPriceCurrency;
(function (StartingPriceCurrency) {
    StartingPriceCurrency["KRW"] = "KRW";
})(StartingPriceCurrency || (StartingPriceCurrency = {}));
export var EntryStatus;
(function (EntryStatus) {
    EntryStatus["RESERVED_OPEN"] = "OPEN";
    EntryStatus["RESERVED_CLOSED"] = "CLOSED";
    EntryStatus["DRAWN"] = "DRAWN";
})(EntryStatus || (EntryStatus = {}));
export var ListingType;
(function (ListingType) {
    ListingType["AUCTION"] = "AUCTION";
    ListingType["INSTANT_PURCHASE"] = "INSTANT_PURCHASE";
    ListingType["GIVEAWAY"] = "GIVEAWAY";
})(ListingType || (ListingType = {}));
export var Classification;
(function (Classification) {
    Classification["SOLD"] = "SOLD";
    Classification["UNSOLD"] = "UNSOLD";
})(Classification || (Classification = {}));
export var EndCause;
(function (EndCause) {
    EndCause["HOST"] = "HOST";
    EndCause["ADMIN_FORCE_END"] = "ADMIN_FORCE_END";
    EndCause["DEALER_ROLE_REVOKED"] = "DEALER_ROLE_REVOKED";
    EndCause["HOST_SIGNAL_LOST"] = "HOST_SIGNAL_LOST";
    EndCause["RESERVED_NULL"] = "null";
})(EndCause || (EndCause = {}));
export var BroadcastStatus;
(function (BroadcastStatus) {
    BroadcastStatus["SCHEDULED"] = "SCHEDULED";
    BroadcastStatus["LIVE"] = "LIVE";
    BroadcastStatus["ENDED"] = "ENDED";
})(BroadcastStatus || (BroadcastStatus = {}));
export var InstantListingsItemListingType;
(function (InstantListingsItemListingType) {
    InstantListingsItemListingType["AUCTION"] = "AUCTION";
    InstantListingsItemListingType["IMMEDIATE_PURCHASE"] = "IMMEDIATE_PURCHASE";
})(InstantListingsItemListingType || (InstantListingsItemListingType = {}));
export var InstantListingsItemAuctionType;
(function (InstantListingsItemAuctionType) {
    InstantListingsItemAuctionType["GENERAL"] = "GENERAL";
    InstantListingsItemAuctionType["FIRST_COME"] = "FIRST_COME";
    InstantListingsItemAuctionType["BLIND"] = "BLIND";
})(InstantListingsItemAuctionType || (InstantListingsItemAuctionType = {}));
export var InstantListingsItemCurrentHighestBidPriceOneOf_0Currency;
(function (InstantListingsItemCurrentHighestBidPriceOneOf_0Currency) {
    InstantListingsItemCurrentHighestBidPriceOneOf_0Currency["KRW"] = "KRW";
})(InstantListingsItemCurrentHighestBidPriceOneOf_0Currency || (InstantListingsItemCurrentHighestBidPriceOneOf_0Currency = {}));
export var InstantListingsItemCurrentMinimumBidPriceCurrency;
(function (InstantListingsItemCurrentMinimumBidPriceCurrency) {
    InstantListingsItemCurrentMinimumBidPriceCurrency["KRW"] = "KRW";
})(InstantListingsItemCurrentMinimumBidPriceCurrency || (InstantListingsItemCurrentMinimumBidPriceCurrency = {}));
export var InstantListingsItemCurrentPriceCurrency;
(function (InstantListingsItemCurrentPriceCurrency) {
    InstantListingsItemCurrentPriceCurrency["KRW"] = "KRW";
})(InstantListingsItemCurrentPriceCurrency || (InstantListingsItemCurrentPriceCurrency = {}));
export var InstantListingsItemAuctionStatus;
(function (InstantListingsItemAuctionStatus) {
    InstantListingsItemAuctionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    InstantListingsItemAuctionStatus["SUCCESSFUL_BID"] = "SUCCESSFUL_BID";
    InstantListingsItemAuctionStatus["NO_BID"] = "NO_BID";
    InstantListingsItemAuctionStatus["CANCELLED"] = "CANCELLED";
})(InstantListingsItemAuctionStatus || (InstantListingsItemAuctionStatus = {}));
export var InstantListingsItemWinningBidAmountOneOf_0Currency;
(function (InstantListingsItemWinningBidAmountOneOf_0Currency) {
    InstantListingsItemWinningBidAmountOneOf_0Currency["KRW"] = "KRW";
})(InstantListingsItemWinningBidAmountOneOf_0Currency || (InstantListingsItemWinningBidAmountOneOf_0Currency = {}));
export var InstantListingsItemInstantPurchaseStatus;
(function (InstantListingsItemInstantPurchaseStatus) {
    InstantListingsItemInstantPurchaseStatus["ON_SALE"] = "ON_SALE";
    InstantListingsItemInstantPurchaseStatus["SOLD_OUT"] = "SOLD_OUT";
    InstantListingsItemInstantPurchaseStatus["ENDED"] = "ENDED";
})(InstantListingsItemInstantPurchaseStatus || (InstantListingsItemInstantPurchaseStatus = {}));
export var InstantListingsItemSalesPriceCurrency;
(function (InstantListingsItemSalesPriceCurrency) {
    InstantListingsItemSalesPriceCurrency["KRW"] = "KRW";
})(InstantListingsItemSalesPriceCurrency || (InstantListingsItemSalesPriceCurrency = {}));
export var ForegroundListingListingType;
(function (ForegroundListingListingType) {
    ForegroundListingListingType["AUCTION"] = "AUCTION";
    ForegroundListingListingType["IMMEDIATE_PURCHASE"] = "IMMEDIATE_PURCHASE";
})(ForegroundListingListingType || (ForegroundListingListingType = {}));
export var ForegroundListingAuctionType;
(function (ForegroundListingAuctionType) {
    ForegroundListingAuctionType["GENERAL"] = "GENERAL";
    ForegroundListingAuctionType["FIRST_COME"] = "FIRST_COME";
    ForegroundListingAuctionType["BLIND"] = "BLIND";
})(ForegroundListingAuctionType || (ForegroundListingAuctionType = {}));
export var ForegroundListingCurrentHighestBidPriceOneOf_0Currency;
(function (ForegroundListingCurrentHighestBidPriceOneOf_0Currency) {
    ForegroundListingCurrentHighestBidPriceOneOf_0Currency["KRW"] = "KRW";
})(ForegroundListingCurrentHighestBidPriceOneOf_0Currency || (ForegroundListingCurrentHighestBidPriceOneOf_0Currency = {}));
export var ForegroundListingCurrentMinimumBidPriceCurrency;
(function (ForegroundListingCurrentMinimumBidPriceCurrency) {
    ForegroundListingCurrentMinimumBidPriceCurrency["KRW"] = "KRW";
})(ForegroundListingCurrentMinimumBidPriceCurrency || (ForegroundListingCurrentMinimumBidPriceCurrency = {}));
export var ForegroundListingCurrentPriceCurrency;
(function (ForegroundListingCurrentPriceCurrency) {
    ForegroundListingCurrentPriceCurrency["KRW"] = "KRW";
})(ForegroundListingCurrentPriceCurrency || (ForegroundListingCurrentPriceCurrency = {}));
export var ForegroundListingAuctionStatus;
(function (ForegroundListingAuctionStatus) {
    ForegroundListingAuctionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ForegroundListingAuctionStatus["SUCCESSFUL_BID"] = "SUCCESSFUL_BID";
    ForegroundListingAuctionStatus["NO_BID"] = "NO_BID";
    ForegroundListingAuctionStatus["CANCELLED"] = "CANCELLED";
})(ForegroundListingAuctionStatus || (ForegroundListingAuctionStatus = {}));
export var ForegroundListingWinningBidAmountOneOf_0Currency;
(function (ForegroundListingWinningBidAmountOneOf_0Currency) {
    ForegroundListingWinningBidAmountOneOf_0Currency["KRW"] = "KRW";
})(ForegroundListingWinningBidAmountOneOf_0Currency || (ForegroundListingWinningBidAmountOneOf_0Currency = {}));
export var ForegroundListingInstantPurchaseStatus;
(function (ForegroundListingInstantPurchaseStatus) {
    ForegroundListingInstantPurchaseStatus["ON_SALE"] = "ON_SALE";
    ForegroundListingInstantPurchaseStatus["SOLD_OUT"] = "SOLD_OUT";
    ForegroundListingInstantPurchaseStatus["ENDED"] = "ENDED";
})(ForegroundListingInstantPurchaseStatus || (ForegroundListingInstantPurchaseStatus = {}));
export var ForegroundListingSalesPriceCurrency;
(function (ForegroundListingSalesPriceCurrency) {
    ForegroundListingSalesPriceCurrency["KRW"] = "KRW";
})(ForegroundListingSalesPriceCurrency || (ForegroundListingSalesPriceCurrency = {}));
export var GiveawaySummaryStatus;
(function (GiveawaySummaryStatus) {
    GiveawaySummaryStatus["IN_PROGRESS"] = "IN_PROGRESS";
    GiveawaySummaryStatus["DRAWING"] = "DRAWING";
    GiveawaySummaryStatus["COMPLETED"] = "COMPLETED";
})(GiveawaySummaryStatus || (GiveawaySummaryStatus = {}));
export var FilesItemApplyPolicy;
(function (FilesItemApplyPolicy) {
    FilesItemApplyPolicy["URGENT"] = "URGENT";
    FilesItemApplyPolicy["IMMEDIATE"] = "IMMEDIATE";
})(FilesItemApplyPolicy || (FilesItemApplyPolicy = {}));
export var SenderType;
(function (SenderType) {
    SenderType["DEALER"] = "DEALER";
    SenderType["BUYER"] = "BUYER";
    SenderType["SYSTEM"] = "SYSTEM";
})(SenderType || (SenderType = {}));
export var Emphasis;
(function (Emphasis) {
    Emphasis["ACCENT"] = "ACCENT";
})(Emphasis || (Emphasis = {}));
export var Reason;
(function (Reason) {
    Reason["TIMEOUT"] = "TIMEOUT";
    Reason["GRACEFUL"] = "GRACEFUL";
})(Reason || (Reason = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["PAYMENT"] = "PAYMENT";
    TransactionType["REFUND"] = "REFUND";
    TransactionType["SETTLEMENT"] = "SETTLEMENT";
    TransactionType["COMMISSION"] = "COMMISSION";
    TransactionType["ADJUSTMENT"] = "ADJUSTMENT";
    TransactionType["REVERSAL"] = "REVERSAL";
})(TransactionType || (TransactionType = {}));
export var EntryLinesItemEntryType;
(function (EntryLinesItemEntryType) {
    EntryLinesItemEntryType["DEBIT"] = "DEBIT";
    EntryLinesItemEntryType["CREDIT"] = "CREDIT";
})(EntryLinesItemEntryType || (EntryLinesItemEntryType = {}));
export var DiscrepancyType;
(function (DiscrepancyType) {
    DiscrepancyType["AMOUNT_MISMATCH"] = "AMOUNT_MISMATCH";
    DiscrepancyType["MISSING_LEDGER_ENTRY"] = "MISSING_LEDGER_ENTRY";
    DiscrepancyType["MISSING_EXTERNAL_RECORD"] = "MISSING_EXTERNAL_RECORD";
    DiscrepancyType["STATUS_MISMATCH"] = "STATUS_MISMATCH";
})(DiscrepancyType || (DiscrepancyType = {}));
export var Severity;
(function (Severity) {
    Severity["LOW"] = "LOW";
    Severity["MEDIUM"] = "MEDIUM";
    Severity["HIGH"] = "HIGH";
    Severity["CRITICAL"] = "CRITICAL";
})(Severity || (Severity = {}));
export var TargetContext;
(function (TargetContext) {
    TargetContext["PAYMENT"] = "PAYMENT";
    TargetContext["SETTLEMENT"] = "SETTLEMENT";
})(TargetContext || (TargetContext = {}));
export var ReservedStatus;
(function (ReservedStatus) {
    ReservedStatus["COMPLETED"] = "COMPLETED";
    ReservedStatus["FAILED"] = "FAILED";
})(ReservedStatus || (ReservedStatus = {}));
export var AccountType;
(function (AccountType) {
    AccountType["ASSET"] = "ASSET";
    AccountType["LIABILITY"] = "LIABILITY";
    AccountType["EQUITY"] = "EQUITY";
    AccountType["REVENUE"] = "REVENUE";
    AccountType["EXPENSE"] = "EXPENSE";
})(AccountType || (AccountType = {}));
export var ChangeType;
(function (ChangeType) {
    ChangeType["PAYMENT_RECEIVED"] = "PAYMENT_RECEIVED";
    ChangeType["SETTLEMENT_PAID"] = "SETTLEMENT_PAID";
    ChangeType["COMMISSION_DEDUCTED"] = "COMMISSION_DEDUCTED";
    ChangeType["REFUND_PROCESSED"] = "REFUND_PROCESSED";
    ChangeType["ADJUSTMENT"] = "ADJUSTMENT";
})(ChangeType || (ChangeType = {}));
export var InitiatedBy;
(function (InitiatedBy) {
    InitiatedBy["SCHEDULED"] = "SCHEDULED";
    InitiatedBy["MANUAL"] = "MANUAL";
})(InitiatedBy || (InitiatedBy = {}));
export var CompensationType;
(function (CompensationType) {
    CompensationType["CREDIT_ADJUSTMENT"] = "CREDIT_ADJUSTMENT";
    CompensationType["DEBIT_ADJUSTMENT"] = "DEBIT_ADJUSTMENT";
    CompensationType["REVERSAL"] = "REVERSAL";
    CompensationType["MANUAL_CORRECTION"] = "MANUAL_CORRECTION";
})(CompensationType || (CompensationType = {}));
export var PriceCurrency;
(function (PriceCurrency) {
    PriceCurrency["KRW"] = "KRW";
    PriceCurrency["USD"] = "USD";
})(PriceCurrency || (PriceCurrency = {}));
export var SalesChannel;
(function (SalesChannel) {
    SalesChannel["BROADCAST"] = "BROADCAST";
    SalesChannel["MARKETPLACE"] = "MARKETPLACE";
})(SalesChannel || (SalesChannel = {}));
export var SlotPriceCurrency;
(function (SlotPriceCurrency) {
    SlotPriceCurrency["KRW"] = "KRW";
    SlotPriceCurrency["USD"] = "USD";
})(SlotPriceCurrency || (SlotPriceCurrency = {}));
export var OrderOrderType;
(function (OrderOrderType) {
    OrderOrderType["AUCTION"] = "AUCTION";
    OrderOrderType["INSTANT_PURCHASE"] = "INSTANT_PURCHASE";
    OrderOrderType["GROUP_BUY"] = "GROUP_BUY";
    OrderOrderType["GIVEAWAY"] = "GIVEAWAY";
})(OrderOrderType || (OrderOrderType = {}));
export var OrderOrderStatus;
(function (OrderOrderStatus) {
    OrderOrderStatus["CREATED"] = "CREATED";
    OrderOrderStatus["PAYMENT_REQUESTED"] = "PAYMENT_REQUESTED";
    OrderOrderStatus["AWAITING_REPAYMENT"] = "AWAITING_REPAYMENT";
    OrderOrderStatus["PAID"] = "PAID";
    OrderOrderStatus["SHIPPED"] = "SHIPPED";
    OrderOrderStatus["DELIVERED"] = "DELIVERED";
    OrderOrderStatus["CONFIRMED"] = "CONFIRMED";
    OrderOrderStatus["CANCELLED"] = "CANCELLED";
    OrderOrderStatus["RETURNED"] = "RETURNED";
    OrderOrderStatus["EXPIRED"] = "EXPIRED";
})(OrderOrderStatus || (OrderOrderStatus = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethodType["DEBIT_CARD"] = "DEBIT_CARD";
    PaymentMethodType["TOSS_PAY_EASY_PAYMENT"] = "TOSS_PAY_EASY_PAYMENT";
})(PaymentMethodType || (PaymentMethodType = {}));
export var MethodType;
(function (MethodType) {
    MethodType["CREDIT_CARD"] = "CREDIT_CARD";
    MethodType["DEBIT_CARD"] = "DEBIT_CARD";
    MethodType["TOSS_PAY_EASY_PAYMENT"] = "TOSS_PAY_EASY_PAYMENT";
})(MethodType || (MethodType = {}));
export var RefundReason;
(function (RefundReason) {
    RefundReason["CUSTOMER_REQUEST"] = "CUSTOMER_REQUEST";
    RefundReason["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    RefundReason["RETURN_APPROVED"] = "RETURN_APPROVED";
    RefundReason["PAYMENT_ERROR"] = "PAYMENT_ERROR";
})(RefundReason || (RefundReason = {}));
export var Gateway;
(function (Gateway) {
    Gateway["TOSS_PAYMENTS"] = "TOSS_PAYMENTS";
    Gateway["STRIPE"] = "STRIPE";
})(Gateway || (Gateway = {}));
export var RefundType;
(function (RefundType) {
    RefundType["CANCELLATION"] = "CANCELLATION";
    RefundType["RESERVED_RETURN"] = "RETURN";
    RefundType["SHIPPING_FEE"] = "SHIPPING_FEE";
})(RefundType || (RefundType = {}));
export var ReasonType;
(function (ReasonType) {
    ReasonType["BUYER_CHANGED_MIND"] = "BUYER_CHANGED_MIND";
    ReasonType["BUYER_FOUND_BETTER_PRICE"] = "BUYER_FOUND_BETTER_PRICE";
    ReasonType["DEALER_OUT_OF_STOCK"] = "DEALER_OUT_OF_STOCK";
    ReasonType["DEALER_CANNOT_FULFILL"] = "DEALER_CANNOT_FULFILL";
})(ReasonType || (ReasonType = {}));
export var PaymentTerms;
(function (PaymentTerms) {
    PaymentTerms["MERCHANT_INITIATED"] = "MERCHANT_INITIATED";
    PaymentTerms["CUSTOMER_INITIATED"] = "CUSTOMER_INITIATED";
})(PaymentTerms || (PaymentTerms = {}));
export var Carrier;
(function (Carrier) {
    Carrier["KOREA_POST"] = "KOREA_POST";
    Carrier["CJ_LOGISTICS"] = "CJ_LOGISTICS";
    Carrier["HANJIN_SHIPPING"] = "HANJIN_SHIPPING";
    Carrier["LOTTE_LOGISTICS"] = "LOTTE_LOGISTICS";
    Carrier["LOGEN_DELIVERY"] = "LOGEN_DELIVERY";
    Carrier["DAESIN"] = "DAESIN";
    Carrier["KYUNGDONG_EXPRESS"] = "KYUNGDONG_EXPRESS";
    Carrier["ILYANG_LOGISTICS"] = "ILYANG_LOGISTICS";
    Carrier["CHUNIL_EXPRESS"] = "CHUNIL_EXPRESS";
    Carrier["HAPDONG_EXPRESS"] = "HAPDONG_EXPRESS";
    Carrier["GS_POSTBOX"] = "GS_POSTBOX";
    Carrier["CU_POST"] = "CU_POST";
    Carrier["KUNYOUNG_EXPRESS"] = "KUNYOUNG_EXPRESS";
    Carrier["WOORI_EXPRESS"] = "WOORI_EXPRESS";
    Carrier["NH_LOGISTICS"] = "NH_LOGISTICS";
})(Carrier || (Carrier = {}));
export var ConfirmationType;
(function (ConfirmationType) {
    ConfirmationType["MANUAL"] = "MANUAL";
    ConfirmationType["AUTOMATIC"] = "AUTOMATIC";
})(ConfirmationType || (ConfirmationType = {}));
export var ShippingOption;
(function (ShippingOption) {
    ShippingOption["STANDARD"] = "STANDARD";
    ShippingOption["QUICK_DIRECT"] = "QUICK_DIRECT";
})(ShippingOption || (ShippingOption = {}));
export var ReturnReason;
(function (ReturnReason) {
    ReturnReason["DEFECTIVE"] = "DEFECTIVE";
    ReturnReason["WRONG_ITEM"] = "WRONG_ITEM";
    ReturnReason["NOT_AS_DESCRIBED"] = "NOT_AS_DESCRIBED";
    ReturnReason["CHANGED_MIND"] = "CHANGED_MIND";
    ReturnReason["OTHER"] = "OTHER";
})(ReturnReason || (ReturnReason = {}));
export var ChangedBy;
(function (ChangedBy) {
    ChangedBy["DEALER"] = "DEALER";
    ChangedBy["ADMIN"] = "ADMIN";
})(ChangedBy || (ChangedBy = {}));
export var PreviousStatus;
(function (PreviousStatus) {
    PreviousStatus["ACTIVE"] = "ACTIVE";
    PreviousStatus["SHIPPED"] = "SHIPPED";
    PreviousStatus["DELIVERED"] = "DELIVERED";
    PreviousStatus["CONFIRMED"] = "CONFIRMED";
    PreviousStatus["ALL_CANCELLED"] = "ALL_CANCELLED";
})(PreviousStatus || (PreviousStatus = {}));
export var CurrentStatus;
(function (CurrentStatus) {
    CurrentStatus["ACTIVE"] = "ACTIVE";
    CurrentStatus["SHIPPED"] = "SHIPPED";
    CurrentStatus["DELIVERED"] = "DELIVERED";
    CurrentStatus["CONFIRMED"] = "CONFIRMED";
    CurrentStatus["ALL_CANCELLED"] = "ALL_CANCELLED";
})(CurrentStatus || (CurrentStatus = {}));
export var TargetType;
(function (TargetType) {
    TargetType["USER"] = "USER";
    TargetType["BROADCAST"] = "BROADCAST";
    TargetType["CHAT"] = "CHAT";
    TargetType["POST"] = "POST";
    TargetType["PRODUCT"] = "PRODUCT";
})(TargetType || (TargetType = {}));
export var ChatType;
(function (ChatType) {
    ChatType["BROADCAST_CHAT"] = "BROADCAST_CHAT";
    ChatType["PRIVATE_DM"] = "PRIVATE_DM";
    ChatType["OPEN_CHAT"] = "OPEN_CHAT";
})(ChatType || (ChatType = {}));
export var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["RESOLVED"] = "RESOLVED";
    ReviewStatus["REJECTED"] = "REJECTED";
})(ReviewStatus || (ReviewStatus = {}));
//# sourceMappingURL=types.js.map